export const Sizes = { width: 210 };
